// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import RTTaiwanBrandVertical from '../_raw/ui/icon_RT_Taiwan_Brand_Vertical.svg';
import withIconProps from '../withIconProps';

export default withIconProps(RTTaiwanBrandVertical, {
  shouldSetDefaultSize: true,
  defaultHeight: 40,
  defaultWidth: 79,
});
